import { Log, apiRequest ,Paginacion } from '@ext/utils';
export * from './Mensaje.types'
import { IMensaje } from './Mensaje.lib';
import { Guid } from 'guid-typescript';

export class Mensaje extends IMensaje {

    public static async create( id: string ): Promise<Mensaje>
    {
        let o = new Mensaje();
        o.Id = id;
        if ( await o.find() ) {
            return o;
        }
        return null;
    }
    protected Route: string = '/mercadolibre/mensajeria/mensajes';
    protected async find(): Promise<boolean> {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() ) {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Mensaje>; Error?: boolean; }> {

        let a: Array<Mensaje> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/mercadolibre/mensajeria/mensajes` );
        request.params = params;
        if ( await request.get() ) {
            if ( request.data.response ) {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results ) {
                for ( let i of request.data.results ) {
                    let p = new Mensaje( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean> {

        try {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe ) {
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.put() ) {
                    this.Json = req.data;
                    this.set();
                }
            }
            else {
                req.path = `${this.Route}`;
                if ( await req.post() ) {
                    this.Json = req.data;
                    this.set();
                }
            }
            return true;
        } catch ( e ) {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean> {

        try {

            if ( this.Existe ) {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() ) {
                    return true;
                }
            }
        } catch ( e ) {
            Log( e );
        }
        return false;
    }

    public static NuevoGuid(): string
    {
        return Guid.create().toString().eliminar( '-' ) + Guid.create().toString().eliminar( '-' );
    }

    public async Recargar(x: any)
    {
        this.Json = x;
        this.set();
    }

    public static async NoLeidos( data: { pack?: number; cliente_id?: number}): Promise<number>
    {
        try
        {
            let req = new apiRequest( `/mercadolibre/mensajeria/mensajes/total` );
            req.params = data;
            req.params.no_leidos = true;
            if ( await req.get() )
            {
                return req.data.total;
            }

        } catch ( e )
        {
            Log( e );
        }
        return 0;
    }

    public static async Todos( data: { pack?: number; cliente_id?: number; } ): Promise<number>
    {
        try
        {
            let req = new apiRequest( `/mercadolibre/mensajeria/mensajes/total` );
            req.params = data;
            if ( await req.get() )
            {
                return req.data.total;
            }

        } catch ( e )
        {
            Log( e );
        }
        return 0;
    }


    public static async SubirEstatico( archivo: string, cuenta: string ): Promise<{ Nombre?: string; URL: string; Tipo: string; }>
    {
        try
        {
            let req = new apiRequest( `/mercadolibre/mensajeria/archivos/estaticos` );
            req.body = {};
            req.body.cuenta = cuenta;
            req.body.archivo = archivo;
            if ( await req.post() )
            {
                return {
                    Nombre: req.data.file_name,
                    Tipo: req.data.file_type,
                    URL: req.data.file_url,
                };
            }

        } catch ( e )
        {
            Log( e );
        }
        return null;
    }

    public static async ObtenerCantidadDisponible(pack: string | number, cuenta: string )
    {
        const req = new apiRequest( `/mercadolibre/mensajeria/${cuenta}/${pack}/disponibles` );
        if(await req.get())
        {
            return req.data;
        }
    }

    public static async SubirURL( archivo: string, cuenta: string ): Promise<{ Nombre?: string; URL: string; Tipo: string; }>
    {
        try
        {
            let req = new apiRequest( `/mercadolibre/mensajeria/archivos/url` );
            req.body = {};
            req.body.cuenta = cuenta;
            req.body.url = archivo;
            if ( await req.post() )
            {
                return {
                    Nombre: req.data.file_name,
                    Tipo: req.data.file_type,
                    URL: req.data.file_url,
                };
            }

        } catch ( e )
        {
            Log( e );
        }
        return null;
    }
}